import { Component } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoaderService } from '../../services/loader.service';

@Component({
    selector: 'app-loader',
    imports: [MatProgressBarModule],
    template: `
  @if (isLoading) {
    <div style="position:fixed; top: 45px; z-index: 9999; width: 100%; height: calc(100% - 45px); background: rgba(255, 255, 255, 0.5);">
      <mat-progress-bar
        class="example-margin"
        [color]="'primary'"
        [mode]="'indeterminate'"
        [value]="40">
      </mat-progress-bar>
    </div>
  }
  `
})
export class LoaderComponent {
  isLoading = false; // This signal will be used to control the loading state
  private loaderSet = new Set(); // Flag to track if the loader has been set
  constructor(
    private loaderService: LoaderService // Inject the loader service
  ) {
    // Subscribe to the loading state from the loader service
    this.loaderService.isLoading().subscribe((res: { loading: boolean, loaderId: string }) => {
      if (res.loaderId && !this.loaderSet.has(res.loaderId) && res.loading) {
        this.isLoading = true;
        document.body.style.overflow = 'hidden'; // Disable scrolling when loading
        this.loaderSet.add(res.loaderId); // Add the loaderId to the set
      } else if (!res.loaderId) {
        this.loaderSet.clear(); // Clear the set if no loaderId is provided
      }
      if(this.loaderSet.has(res.loaderId) && !res.loading) {
        this.loaderSet.delete(res.loaderId); // Remove the loaderId from the set if loading is false
      }
      if(this.loaderSet.size === 0) {
        document.body.style.overflow = 'auto'; // Disable scrolling when loading
        this.isLoading = false; // If no loaders are active, set isLoading to false
      }
    });
  }
}